import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    // With standalone Google OAuth, the session cookie is set server-side.
    // Just check auth and redirect.
    checkAuth().then(() => {
      navigate("/dashboard", { replace: true });
    }).catch(() => {
      navigate("/login", { replace: true });
    });
  }, [checkAuth, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#4338ca] border-t-transparent mx-auto mb-4" />
        <p className="text-sm text-[#64748b]">Signing you in...</p>
      </div>
    </div>
  );
}
